export type AppMode = 'superadmin' | 'tenant';

/**
 * Bepaal welk SPA-shell we renderen op basis van de hostname.
 *  - `admin.<central>` of `admin.<central>:<port>` → superadmin
 *  - alles anders → tenant (subdomein wordt server-side resolved)
 */
export function resolveAppMode(hostname: string): AppMode {
  const adminPrefix = 'admin.';
  return hostname.startsWith(adminPrefix) ? 'superadmin' : 'tenant';
}
